// @flow

import React, { Component } from 'react';

import { Grid, Cell } from 'react-flexr';

import Input from './input';
import SelectField from './select-field';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import i18n from 'app/common/i18n';

class FormInputWithComment extends Component {
  i18n: string => string;

  static propTypes = {};

  constructor(props) {
    super(props);

    const isArrayInput = /\[\]$/.test(props.name);
    const defaultValue = {};

    const value =
      (props.defaultValue &&
        (isArrayInput
          ? props.defaultValue.filter((t) => t.key === props.formKey)[0]
          : props.defaultValue)) ||
      defaultValue;

    const showCommentField = props.showCommentLogic
      ? props.showCommentLogic(value)
      : props.showCommentField || false;

    this.state = { value, showCommentField };
  }

  handleChange = (ev) => {
    const value = {
      ...this.state.value,
      key: this.props.formKey || this.state.value.key,
      [ev.target.name]:
        ev.target.type === 'checkbox' ? ev.target.checked : ev.target.value
    };

    value.value = this._deserializeValue(value.value);

    const showCommentField = this.props.showCommentLogic
      ? this.props.showCommentLogic(value)
      : this.state.showCommentField;

    this.setState({ value, showCommentField });

    const proxyEvent = {
      target: {
        name: this.props.name,
        value: value,
        type: 'mixed'
      }
    };
    this.props.onChange(proxyEvent);
  };

  _serializeValue(value: mixed): string {
    try {
      return value === null
        ? '__null__'
        : typeof value === 'string'
        ? value
        : `__json__${JSON.stringify(value)}`;
    } catch (e) {
      if (__DEV__) {
        console.error(e);
      }
      return value;
    }
  }

  _deserializeValue(value: string): mixed {
    try {
      return value === '__null__'
        ? null
        : /^__json__/.test(value)
        ? JSON.parse(value.replace('__json__', ''))
        : value;
    } catch (e) {
      if (__DEV__) {
        console.error(e);
      }
      return value;
    }
  }

  render() {
    const { value, showCommentField } = this.state;
    const {
      defaultValue, // eslint-disable-line no-unused-vars
      onChange, // eslint-disable-line no-unused-vars
      showCommentLogic, // eslint-disable-line no-unused-vars
      userDefinedLabel, // eslint-disable-line no-unused-vars
      commentHint,
      name,
      error,
      errors,
      type,
      formKey,
      label,
      options,
      i18n,
      ...props
    } = this.props;

    const valueKey = 'value';

    let primary;

    const err =
      error ||
      (errors &&
        this.props.defaultValue.reduce((acc, item, idx) => {
          if (!acc && item.key === formKey) {
            const path = new RegExp(
              `^${name.replace('[]', '')}.${idx}.`.replace(/\./g, '\\.')
            );
            return Object.keys(errors).reduce((acc, key) => {
              if (!acc && path.test(key)) {
                return errors[key];
              }
              return acc;
            }, acc);
          }
          return acc;
        }, null));

    if (err) {
      props.errorText = i18n(typeof err === 'string' ? err : err.message);
    }

    if (options) {
      primary = (
        <SelectField
          value={this._serializeValue(value[valueKey] || false)}
          name={valueKey}
          fullWidth
          label={label}
          options={options.map(({ value, ...opt }) => ({
            ...opt,
            value: this._serializeValue(value)
          }))}
          onChange={this.handleChange}
          {...props}
        />
      );
    } else if (type) {
      primary = (
        <Input
          type={type}
          label={label}
          defaultValue={value[valueKey]}
          name={valueKey}
          onChange={this.handleChange}
          {...props}
        />
      );
    } else {
      primary = (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={value[valueKey] || false}
              name={valueKey}
              onClick={this.handleChange}
              {...props}
            />
          }
          label={label}
        />
      );
    }

    return (
      <Grid style={{ marginBottom: 0 }}>
        <Cell>{primary}</Cell>

        {showCommentField ? (
          <Cell>
            <Input
              label={i18n('Comments?')}
              InputLabelProps={{ style: { whiteSpace: 'pre' } }}
              helperText={commentHint}
              defaultValue={value.comment}
              name="comment"
              type="text"
              onChange={this.handleChange}
              fullWidth
            />
          </Cell>
        ) : null}
      </Grid>
    );
  }
}

export default i18n(FormInputWithComment);